import App, {Tool} from "../App";
import Api from "./Api";
import Resource from "../Resource";
import {HospitalWashRequest} from './WashRequest';

class IrradiateRequest {
    static data(props) {
        App.log('IRRADIATE_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        const data = result.objList[0] || {};

                        resolve({...data?.requestInfo, ...data?.sectionRadiatedRequestFormVM});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static delete(props) {
        App.log('SECTION_IRRADIATE_REQUEST.DELETE', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId,
            statusId: 21
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.UPDATE_STATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.DELETE_FAILED);
            });
        });
    }
}

class SectionIrradiateRequest extends IrradiateRequest {
    static insert(props) {
        App.log('SECTION_IRRADIATE_REQUEST.INSERT', App.LOG.FETCH, props);

        const body = {
            patientFileCodeId: props.patientFileCodeId,
            predicteInjectionDateTime: props.predicteInjectionDateTime,
            probablyDiagnosticStr: props.probablyDiagnosticStr,
            peyvandOlozhinc: props.peyvandOlozhinc,
            sandron: props.sandron,
            faravardeh: props.faravardeh,
            darman: props.darman,
            platelet: props.platelet,
            vahed: props.vahed,
            nozad: props.nozad,
            peyvandOrgan: props.peyvandOrgan,
            tazrig: props.tazrig,
            bimari: props.bimari,
            lanfom: props.lanfom,
            anemy: props.anemy,
            docterId: props.docterId,
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.IRRADIATE.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static list() {
        App.log('SECTION_IRRADIATE_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.IRRADIATE.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static update(props) {
        App.log('SECTION_IRRADIATE_REQUEST.UPDATE', App.LOG.FETCH, props);

        const body = {
            sectionRadiatedRequestId: props.sectionRadiatedRequestId,
            patientFileCodeId: props.patientFileCodeId,
            predicteInjectionDateTime: props.predicteInjectionDateTime,
            probablyDiagnosticStr: props.probablyDiagnosticStr,
            peyvandOlozhinc: props.peyvandOlozhinc,
            sandron: props.sandron,
            faravardeh: props.faravardeh,
            darman: props.darman,
            platelet: props.platelet,
            vahed: props.vahed,
            nozad: props.nozad,
            peyvandOrgan: props.peyvandOrgan,
            tazrig: props.tazrig,
            bimari: props.bimari,
            lanfom: props.lanfom,
            anemy: props.anemy,
            docterId: props.docterId,
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.IRRADIATE.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }
}

class HospitalIrradiateRequest extends IrradiateRequest {
    static addProduct(props) {
        App.log('HOSPITAL_IIRADIATE_REQUEST.ADD_PRODUCT', App.LOG.FETCH, props);

        // const body = {
        //     sectionRequestId: props.sectionRequestId,
        //     crossMatchIdList: props.crossMatchIdList
        // };

    }

    static list() {
        App.log('HOSPITAL_IRRADIATE_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.HOSPITAL.IRRADIATE.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static removeProduct(props) {
        App.log('HOSPITAL_IIRADIATE_REQUEST.REMOVE_PRODUCT', App.LOG.FETCH, props);

        return HospitalIrradiateRequest.removeProduct(props);
    }

    static sendRequestToOrg(props) {
        App.log('HOSPITAL_IIRADIATE_REQUEST.SEND_REQUEST_TO_ORG', App.LOG.FETCH, props);

        return HospitalWashRequest.sendRequestToOrg(props);
    }
}

class OrganizationIrradiateRequest extends IrradiateRequest {
    static data(props) {
        App.log('ORGANIZATION_IRRADIATE_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            hospitalRequestId: props.hospitalRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0].hospitalRadiatedRequestFormVM, ...result.objList[0].requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static list() {
        App.log('ORGANIZATION_IRRADIATED_REQUEST.LIST', App.LOG.FETCH);

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.ORG.IRRADIATE.LIST, {
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }
}


export {SectionIrradiateRequest, HospitalIrradiateRequest, OrganizationIrradiateRequest};